import { render, staticRenderFns } from "./sendinvite.vue?vue&type=template&id=d470b89a&"
import script from "./sendinvite.vue?vue&type=script&lang=js&"
export * from "./sendinvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports